"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toStringPath(path) {
    return "/" + path.join("/");
}
exports.toStringPath = toStringPath;
function toArrayPath(path) {
    let arrayPath = path.split("/");
    if (arrayPath.length > 0 && arrayPath[0] == "") {
        arrayPath.shift();
    }
    if (arrayPath.length > 0 && arrayPath[arrayPath.length - 1] == "") {
        arrayPath.pop();
    }
    return arrayPath;
}
exports.toArrayPath = toArrayPath;
function getObjectAtPath(tree, path) {
    return path.reduce((acc, nextKey) => {
        if (acc[nextKey]) {
            return acc[nextKey];
        }
        else if (acc["*"]) {
            return acc["*"];
        }
        else {
            throw new Error("Specified path /" + path.join('/') + " does not exist in the tree.");
        }
    }, tree);
}
exports.getObjectAtPath = getObjectAtPath;
function toTreePath(tree, path) {
    let treePath = [];
    path.reduce((acc, nextKey) => {
        if (acc[nextKey]) {
            treePath.push(nextKey);
            return acc[nextKey];
        }
        else if (acc["*"]) {
            treePath.push("*");
            return acc["*"];
        }
        else {
            throw new Error("Specified path /" + path.join('/') + " does not exist in the tree.");
        }
    }, tree);
    return treePath;
}
exports.toTreePath = toTreePath;
function isResource(tree, path) {
    const obj = getObjectAtPath(tree, path);
    if ("_id" in obj) {
        return true;
    }
    else {
        return false;
    }
}
exports.isResource = isResource;
function createNestedObject(obj, nestPath) {
    const reversedArray = nestPath.slice().reverse();
    return reversedArray.reduce((acc, nextKey) => {
        let newObj = {};
        newObj[nextKey] = acc;
        return newObj;
    }, obj);
}
exports.createNestedObject = createNestedObject;
function delay(ms) {
    return new Promise((_) => setTimeout(_, ms));
}
exports.delay = delay;
//# sourceMappingURL=utils.js.map